"use strict";const e=require("./_commonjsHelpers-6763f629.js"),r=require("./extends-7fef164d.js"),s=e.getAugmentedNamespace(r._extends$1);exports.require$$1=s;
